module.exports = __webpack_public_path__ + "static/media/RR_S_02.109d78fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/shoes/RR_S_02.png
// module id = 62
// module chunks = 0